// @flow
import { connect } from 'react-redux';
import BreadcrumbComponent from './index';
import { breadcrumbSelector, getTypeId } from '../../Serp/selectors';
import type { BreadcrumbType } from '../../components/desktop/Breadcrumb/types/breadcrumb';

type MapStateToProps = {
  breadcrumb: ?BreadcrumbType,
  dealType: ?number,
};

function mapStateToProps(state: Object): MapStateToProps {
  return {
    breadcrumb: breadcrumbSelector(state),
    dealType: getTypeId(state),
  };
}

const BreadcrumbContainer = connect(
  mapStateToProps,
  null
)(BreadcrumbComponent);

BreadcrumbContainer.displayName = 'BreadcrumbContainer';

export default BreadcrumbContainer;



// WEBPACK FOOTER //
// ./app/common/Breadcrumb/container.js